import { BusinessUnitService } from './business-unit.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BUSINESS_UNIT_TYPE, BusinessUnit } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class BusinessUnitResolverBase implements Resolve<BusinessUnit> {

  constructor(protected service: BusinessUnitService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BusinessUnit> {
    const key: string = BUSINESS_UNIT_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



